;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .controller('csVulnerabilityStackTraceCtrl', csVulnerabilityStackTraceCtrl)

  function csVulnerabilityStackTraceCtrl(AGENT_LANGUAGE) {
    'ngInject'

    var vm
    this.$onInit = function () {
      vm = this
      angular.extend(vm, {
        getTemplateUrl: getTemplateUrl
      })
    }

    function getTemplateUrl() {
      var template =
        'components/vulnerabilities/cs-vulnerability-stack-trace-default.html'

      if (vm.frame.type == 'common') {
        var signature = vm.frame.description.substring(
          0,
          vm.frame.description.indexOf('(')
        )

        if (_.includes(AGENT_LANGUAGE.JAVA, vm.language)) {
          vm.frame.linkOpenSource =
            'https://searchcode.com/?q=class ' + signature + '&lan=23'

          template =
            'components/vulnerabilities/cs-vulnerability-stack-trace-common.html'
        }
      }

      return template
    }
  }
})()
